import { DatabaseEntities } from "../../../common/models/database-entities.model";

export class SpreaderWheels extends DatabaseEntities<SpreaderWheels> {
    value: string;
}
